import { BaseApiRouteService } from "mrb/core";

class UserSettingsApiRouteService extends BaseApiRouteService {
    constructor() {
        super("user-settings");
    }

    updateIsTutorialPassed(isTutorialPassed) {
        return super.update(`${this.base}/tutorial-passed{?value}`, {
            value: isTutorialPassed,
        });
    }

    disableContentPolicy() {
        return super.update(`${this.base}/content-policy/disable`);
    }

    disableTorahAnytimeAvailability() {
        return super.update(`${this.base}/torah-anytime-availability/disable`);
    }

    disableConnectDevice() {
        return super.update(`${this.base}/connect-device/disable`);
    }

    disableContentUnavailableInAppPolicy() {
        return super.update(`${this.base}/content-unavailable-policy/disable`);
    }

    updateContentMode(value) {
        return super.update(`${this.base}/content-mode{?value}`, {
            value: value,
        });
    }

    getCertifiedMode() {
        return super.get(`${this.base}/certified-mode`);
    }

    updateCertifiedMode(certifiedModeId, whitelistMode = false) {
        return super.update(`${this.base}/certified-mode{?certifiedModeId,whitelistMode}`, {
            certifiedModeId,
            whitelistMode,
        });
    }

    updateHideTrending(value) {
        return super.update(`${this.base}/trending/hide{?value}`, {
            value: value,
        });
    }

    getHideTrending() {
        return super.get(`${this.base}/trending/hide`);
    }
}

export default UserSettingsApiRouteService;
